module.exports = "/7a3ef20d158e5b6baad5e7ccb27e850d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/brands/smirnoff.png
 ** module id = 2208
 ** module chunks = 0
 **/